import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { appointmentDraftSelectors, bookingsSelectors } from '~/api';
import { envConfigSelectors } from '../configuration';

export const withMeta = (WrappedComponent) => {
  function ComponentWithMeta({ metaDescription, ...restProps }) {
    return (
      <>
        {metaDescription && (
          <>
            <meta name="description" content={metaDescription} />
            <meta property="og:description" content={metaDescription} />
          </>
        )}
        <WrappedComponent {...restProps} />
      </>
    );
  }

  ComponentWithMeta.propTypes = {
    metaDescription: PropTypes.string,
  };

  ComponentWithMeta.displayName = `WithMeta(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return ComponentWithMeta;
};

export const mapStateToProps = (state) => {
  const draftAppointmentTypeId = appointmentDraftSelectors.selectAppointmentTypeId(state);
  const bookingAppointmentTypeId = bookingsSelectors.selectAppointmentTypeId(state);
  const appointmentTypeId = draftAppointmentTypeId || bookingAppointmentTypeId;

  return {
    metaDescription: envConfigSelectors.selectMetaDescription(appointmentTypeId)(state),
  };
};

export const ConnectedWithMeta = (Component) => connect(mapStateToProps)(withMeta(Component));
